<template>
  <v-container fluid grid-list-lg class="grey lighten-3 py-10">
    <v-layout
      my-12
      :row="$vuetify.breakpoint.mdAndUp"
      :column="$vuetify.breakpoint.smAndDown"
      :justify-center="$vuetify.breakpoint.mdAndDown"
    >
      <v-flex
        xs12
        sm12
        md4
        lg2
        my-7
        text-center
        v-for="(item, index) in offer"
        :key="index"
      >
        <router-link :to="item.link">
          <v-avatar
            :class="[index == isOnHover.index && isOnHover.isOnHover ?'mb-5 animated':'mb-5']"
            @mouseover="imageover(index)"
            @mouseleave="imageleave()"
            size="120"
            color="#111f3c"
          >
            <v-img contain height="80" width="80" :src="renderImage(item.logo_btn)" alt="John"></v-img>
          </v-avatar>
        </router-link>

        <h2 class="text-uppercase font-weight-light">
          Licenciatura en
          <span class="font-weight-bold">{{item.name}}</span>
        </h2>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<style scoped>
.animated {
  -webkit-animation: bounce 0.5s infinite alternate;
  animation: bounce 0.5s infinite alternate;
}
@-webkit-keyframes bounce {
  to {
    -webkit-transform: scale(1.1);
  }
}
@keyframes bounce {
  to {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
}
</style>
<script>
import { mask } from "vue-the-mask";
import { mapState, mapGetters } from "vuex";
export default {
  name: "App",
  directives: {
    mask
  },
  data() {
    return {
      publicPath: process.env.BASE_URL,
      carrer: [
        {
          name: "administración de empresas",
          img: "images/iconos/licenciaturas_admin.png",
          router: "/Administracion-de-empresas"
        },
        {
          name: "ciencias de la educación",
          img: "images/iconos/licenciaturas_edu.png",
          router: "/Ciencias-de-la-educacion"
        },
        {
          name: "comercio internacional",
          img: "images/iconos/licenciaturas_comercio.png",
          router: "/Comercio"
        },

        {
          name: "contaduría",
          img: "images/iconos/licenciaturas_conta.png",
          router: "/Contaduria"
        },
        {
          name: "derecho",
          img: "images/iconos/licenciaturas_derecho.png",
          router: "/Derecho"
        }
      ],
      isOnHover: {
        index: 0,
        isOnHover: false
      }
    };
  },
  computed: {
    ...mapState({
      offer: state => state.home.offer,
    })
  },
  methods: {
    renderImage(image){
      if(image.indexOf("https")<0){
        return "https://www.admin-uva.tidingo.com"+image;
      }else{
        return image;
      }
    },
    imageover(index) {
      this.isOnHover.index = index;
      this.isOnHover.isOnHover = true;
    },
    imageleave() {
      this.isOnHover.isOnHover = false;
    }
  }
};
</script>